import SectionHeading from "@/components/feature/SectionHeading";

const values = [
  { icon: "ri-focus-3-line", title: "专注游戏漫画情报", text: "持续深耕游戏资讯与漫画化、联动情报，不做泛娱乐流水账，只聚焦真正的游戏漫画动态。" },
  { icon: "ri-rocket-2-line", title: "抢先一步的时效", text: "紧跟官方发布会与公告节奏，第一时间整理新游漫画化、版本更新漫画与活动漫画内容。" },
  { icon: "ri-shield-check-line", title: "信息来源可靠", text: "所有情报均基于官方公告、公开资料与权威渠道整理，力求真实、准确、可追溯。" },
];

const testimonials = [
  { name: "游戏玩家·小夏", text: "之前总是错过新游漫画化的企划公告，自从关注可游漫画网，热门游戏的漫画化动态基本没再错过。" },
  { name: "情报爱好者·阿哲", text: "版本更新漫画的解析很及时，尤其是活动漫画里的隐藏彩蛋，讲得很清楚，追更体验很好。" },
  { name: "联动玩家·晚晚", text: "联动情报整理得非常细，跨IP联动的时间线和奖励都说得很明白，省了很多自己翻公告的时间。" },
];

export default function BrandSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        kicker="品牌介绍"
        title="为什么选择可游漫画网"
        desc="我们专注把游戏资讯、联动情报与漫画内容做成高效的信息入口。"
        align="center"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {values.map((v) => (
          <div key={v.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
            <span className="manga-clip-both flex h-10 w-10 items-center justify-center bg-secondary-500 text-background-50">
              <i className={`${v.icon} text-lg`} />
            </span>
            <h3 className="mt-4 font-heading text-base text-foreground-950">{v.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.text}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 rounded-lg bg-background-100 p-6 md:p-10">
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <h3 className="font-heading text-xl text-foreground-950 md:text-2xl">读者口碑</h3>
          <div className="flex items-center gap-1 text-accent-500">
            {Array.from({ length: 5 }).map((_, i) => (
              <i key={i} className="ri-star-fill text-lg" />
            ))}
            <span className="ml-1 text-sm font-bold text-foreground-700">4.9 / 5</span>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          {testimonials.map((t) => (
            <div key={t.name} className="rounded-lg bg-background-50 p-5">
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" />
                ))}
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">“{t.text}”</p>
              <p className="mt-3 text-xs font-bold text-foreground-500">{t.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}